import SettingsVM from './settings-vm';

export default {
  init(ele) {
    const data = JSON.parse($('#settings_json').val());
    const terms = JSON.parse($('#terms_json').val());
    ko.applyBindingsWithValidation(new SettingsVM(data, terms), ele);
  }
};

